module.exports = __webpack_public_path__ + "static/media/web3.4e14957c.jpg";